import { render, staticRenderFns } from "./productionPanel.vue?vue&type=template&id=48e695ad&"
import script from "./productionPanel.vue?vue&type=script&lang=js&"
export * from "./productionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports